module.exports = __webpack_public_path__ + "img/logo-white.c186a540.png";